import { createContext, useContext } from 'react'

export const ModalContext = createContext<{
	isOpen: boolean
	onClose: () => void
} | null>(null)

export const useModalContext = () => {
	const context = useContext(ModalContext)

	if (context === null) {
		throw new Error(
			'useModalContext must be used within a ModalContextProvider'
		)
	}

	return context
}
